﻿import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { createMuiTheme } from '@material-ui/core/styles'; // v1.x
import { blue400, blue300 } from 'material-ui/styles/colors';
// import { white } from '@material-ui/core/colors';
import { nursing500, nursing200, nursing800, claraA500 } from '../theme/AllocateColors';
// import allocateIconsEot from '../../wwwroot/fonts/allocate-icons/allocateicons-regular-webfont.eot';

const communityThemeV0 = getMuiTheme({
  palette: {
    primary1Color: nursing500,
    primary2Color: nursing200,
    primary3Color: nursing800,
    accent1Color: claraA500,
    accent2Color: blue400,
    accent3Color: blue300,
  },
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 60, // left-nav width = this * 4
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopLeftNavMenuItemHeight: 30,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56,
  },
});

const communityTheme = createMuiTheme({
  typography: {
    h1: {
      fontSize: 40,
      fontFamily: 'Roboto',
      fontWeight: '300',
    },

    h2: {
      fontSize: 22,
      lineHeight: 1.2,
      fontFamily: 'Roboto',
      fontWeight: '500',
    },

    h3: {
      fontSize: 20,
      lineHeight: 1.2,
      fontFamily: 'Roboto',
      fontWeight: '400',
    },

    h4: {
      fontSize: 14,
      lineHeight: 1.2,
      fontFamily: 'Roboto',
      fontWeight: '500',
      color: '#368EA7',
    },

    h5: {
      fontSize: 14,
      lineHeight: 1.2,
      fontFamily: 'Roboto',
      fontWeight: '500',
      color: '#555555',
    },

    h6: {
      fontSize: 14,
      lineHeight: 1.2,
      fontFamily: 'Roboto',
      fontWeight: '500',
      color: '#666666',
    },

    subtitle1: {
      fontSize: 13,
      lineHeight: 1.2,
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#999999',
    },

    subtitle2: {
      fontSize: 11,
      lineHeight: 1.2,
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#999999',
    },

    body1: {
      fontSize: 13,
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#000000',
    },

    body2: {
      fontSize: 14,
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#707070',
    },

    caption: {
      fontSize: 10,
      lineHeight: 1.1,
      fontFamily: 'Roboto',
      fontWeight: '400',
      color: '#999999',
    },

    // button: {
    //   fontSize: 14,
    //   fontFamily: 'robotomedium',
    //   color: '#666666',
    //   textDecoration: 'underline',
    //   height: '36px',
    // },

    input: {
      fontSize: '0.0rem',
    },
  },
  overrides: {
    MUIDataTableToolbar: {
      actions: {
        display: 'flex',
        flexDirection: 'row',
        flex: 'initial',
      },
    },
  },
});

export { communityThemeV0, communityTheme };
